import { ServerCurrency } from '@yoop/server-model/payment';

/**
 * Use `Currency` on client side models and code instead of `ServerCurrency`
 * for clear server-client boundary.
 */
export const Currency = ServerCurrency;
export type Currency = ServerCurrency;
